/** Redirect (to external URL)
 *
 * Redirects the user to the specified URL. Has a similar, though simplified,
 * api to React Router's `navigate` function.
 *
 * However, this function performs a full page reload to the specified URL
 * and never resolves. It should be used when navigating outside of the
 * React application.
 *
 * @param to - The URL to redirect to
 * @param opts - Optional settings for the redirection
 *
 */
export const redirect = (to: string | URL, opts?: { replace?: boolean }) => {
  return new Promise<void>(() => {
    if (opts?.replace) window.location.replace(to);
    else window.location.assign(to);
  });
};
